import Container from "../components/common/Container";
import EmployeesTable from "../components/Employees/Table";
import PageHeader from "../components/common/PageHeader";
import { useLocation, useNavigate } from "react-router";
import PlusIcon from "../components/common/Icons/PlusIcon";

const Employees = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Container>
      <PageHeader
        pageTitle="Çalışanlar"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Çalışan"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <EmployeesTable />
    </Container>
  );
};

export default Employees;
